import {AttributeDefinitions, Orientation, TabSetNode} from '../'
import {FlexLayoutNode, Model, RowNode} from '.'
import {action, computed, deepdash, observable} from '@api'
import {FLEX_WEIGHT_DEFAULT, FLEX_WEIGHT_TOOLBOX_SIDEBAR } from '@stores/catalog/flexLayout'

export class SplitterNode extends FlexLayoutNode {
  @action override delete = () => {
    const {leftOrTop, rightOrBottom, parent} = this,
      findTabSet = (node: FlexLayoutNode) => node instanceof TabSetNode ? node : deepdash.findDeep(node.children, (v, k, parent) => {
        return v instanceof TabSetNode
      }, {checkCircular: true, childrenPath: ['children']})?.value as TabSetNode,
      leftTabSet = findTabSet(leftOrTop),
      rightTabSet = findTabSet(rightOrBottom)

    if (!leftTabSet || !rightTabSet) debugger

    /**
     * Before:
     *  A  |  B
     *  A  |  C
     *
     *  After:
     *
     *  AB
     *  --
     *  CC
     */

    const mergeTo = leftTabSet.parent != parent ? leftTabSet : rightTabSet,
      mergeFrom = leftTabSet === mergeTo ? rightTabSet : leftTabSet

    // console.log({mergeFrom, mergeTo})
    mergeTo.addChildren(mergeFrom.children)
    mergeFrom.removeFromParent(false)
  }

  @action onCollapseLeftOrUp = () => {
    this.leftOrTop._setWeight(0)
    this.rightOrBottom._setWeight(1)
    this.model.updateAndLayout()
  }

  @action onExpandRightOrDown = () => {
    this.leftOrTop._setWeight(1)
    this.rightOrBottom._setWeight(0)
    this.model.updateAndLayout()
  }

  static readonly TYPE: string = 'splitter'

  /** @hidden @internal */
  constructor(model: Model) {
    super(model)
    this._fixed = true
    this._attributes.type = SplitterNode.TYPE
    model._addNode(this)
  }

  @computed get row() { return this.parent as RowNode }

  @computed get leftOrTop() {
    const {indexInParent: i, row: {drawChildren}} = this
    return drawChildren[i - 1] as RowNode | TabSetNode
  }

  @observable lastSplitWeights : {l: number, r: number} = null

  @computed get rightOrBottom() {
    const {indexInParent: i, row: {drawChildren}} = this
    return drawChildren[i + 1] as RowNode | TabSetNode
  }

  @computed get areEquallyWeighted() {
    return this.leftOrTop.weight === this.rightOrBottom.weight
  }

  @computed get isLeftRightSplit() {
    return this.row.isHorizontal
  }

  @computed get isTopBottomSplit() {
    return !this.row.isHorizontal
  }

  /** @hidden @internal */
  @computed get width() {
    return this._model.splitterSize
  }

  /** @hidden @internal */
  @computed get minWidth() {
    if (this.orientation === Orientation.VERT) {
      return this._model.splitterSize
    } else {
      return 0
    }
  }

  /** @hidden @internal */
  @computed get height() {
    return this._model.splitterSize
  }

  /** @hidden @internal */
  @computed get minHeight() {
    if (this.orientation === Orientation.HORZ) {
      return this._model.splitterSize
    } else {
      return 0
    }
  }

  /** @hidden @internal */
  getMinSize = (orientation: Orientation) => {
    if (orientation === Orientation.HORZ) {
      return this.minWidth
    } else {
      return this.minHeight
    }
  }

  /** @hidden @internal */
  @computed get weight(): number {
    return 0
  }

  /** @hidden @internal */
  _setWeight = (value: number): void => {}

  /** @hidden @internal */
  _getPrefSize = (orientation: Orientation): number => {
    return this._model.splitterSize
  }

  /** @hidden @internal */
  _updateAttrs = (json: any): void => {}

  /** @hidden @internal */
  _getAttributeDefinitions = (): AttributeDefinitions => {
    return new AttributeDefinitions()
  }

  /** @hidden @internal */
  get asJson(): any {
    return undefined
  }

  @action onDoubleClick = () => this.toggleSplitWeights()

  @action toggleSplitWeights = () => {
    const {leftOrTop: left, rightOrBottom: right, areEquallyWeighted, model, flexLayout: {knownTabs}} = this

    if (!this.lastSplitWeights && !areEquallyWeighted && left.weight != 0 && right.weight != 0) {
      this.lastSplitWeights = {l: left.weight, r: right.weight}
    }

    const {lastSplitWeights} = this,
      defaultWeight = knownTabs[left.id] ? FLEX_WEIGHT_TOOLBOX_SIDEBAR : FLEX_WEIGHT_DEFAULT

    if (left.weight === 0 || right.weight === 0) {
      left._setWeight(defaultWeight)
      right._setWeight(defaultWeight)
    }
    else if (left.weight > right.weight) {
      right._setWeight(0)
    }
    else if (left.weight < right.weight) {
      left._setWeight(0)
    }
    else {
      if (!lastSplitWeights) {
        right._setWeight(0)
      }
      else {
        left._setWeight(lastSplitWeights.l)
        right._setWeight(lastSplitWeights.r)
      }
    }

    model.updateAndLayout()

    // model.doAction(Actions.adjustSplit(
    //   leftOrTop.id,
    //   knownTabs[leftOrTop.id] ? FLEX_WEIGHT_TOOLBOX_SIDEBAR : FLEX_WEIGHT_DEFAULT,
    //   rightOrBottom.id,
    //   knownTabs[rightOrBottom.id] ? FLEX_WEIGHT_TOOLBOX_SIDEBAR : FLEX_WEIGHT_DEFAULT,
    // ))
  }
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/model/SplitterNode.ts